export class IAppsManagement {
  accessDelibe: boolean;
  pourAction: number;
}
